// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__pUnOl","col":"styles_col__uwSOD"};